import { render, staticRenderFns } from "./Transference.vue?vue&type=template&id=781ee272&"
import script from "./Transference.vue?vue&type=script&lang=js&"
export * from "./Transference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports